import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import { Button, Card, CardBody } from "reactstrap";

const options = {
  sortIndicator: true,
  hideSizePerPage: false,
  paginationSize: 3,
  hidePageListOnlyOnePage: false,
  clearSearch: true,
  alwaysShowAllBtns: true,
  withFirstAndLast: true,
};

export default function PaymentDueBeatBodyItems({ data, onBack }) {
  return (
    <div>
      <Button
        className="btn btn-info"
        id="back"
        onClick={() => onBack()}
        style={{ marginLeft: "5px", marginBottom: "5px" }}
      >
        <i className="fa fa-arrow-left" />
      </Button>
      <BootstrapTable
        data={data}
        version="4"
        condensed={true}
        striped
        hover
        pagination
        search
        options={options}
        exportCSV
        csvFileName="Bank_account_details.csv"
      >
        <TableHeaderColumn isKey dataField="id" export={false} hidden={true}>
          ID
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="beatName"
          csvHeader="beatName"
          export={true}
          hidden={false}
          filter={{ type: "TextFilter", delay: 1000 }}
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
        >
          Beat Name
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="salesPersonName"
          export={true}
          hidden={false}

        >
          Sales Person Name
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="billDate"
          csvHeader="billDate"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
          editable={true}
        >
          Bill Date
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="invoiceNumber"
          csvHeader="invoiceNumber"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
          editable={true}
        >
          Invoice Number
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="partyName"
          csvHeader="partyName"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
          editable={true}
        >
          Party Name
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="status"
          csvHeader="status"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
          editable={true}
        >
          Status
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="billValue"
          csvHeader="Bill Value"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
          editable={true}
        >
          Bill Value
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="balance"
          csvHeader="balance"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
          editable={true}
        >
          Balance Due
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="dueForDays"
          csvHeader="dueForDays"
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
          filter={{
            type: "NumberFilter",
            delay: 1000,
            numberComparators: ["=", ">", "<"],
          }}
        >
          Days
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="paymentGapDays"
          csvHeader="Payment Gap Days"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
        >
          Payment Gap Days
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="avgBillPaidDays"
          csvHeader="Average Bill Paid Days"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
        >
          Average Bill Paid Days
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="paymentTerm"
          csvHeader="Payment Term"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataSort
          tdStyle={{ whiteSpace: "normal" }}
          thStyle={{ whiteSpace: "normal" }}
        >
          Payment Term
        </TableHeaderColumn>
      </BootstrapTable>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/PaymentDueBeatBodyItems.js